import { render, staticRenderFns } from "./CustomerDialog.vue?vue&type=template&id=3ccc95ec"
import script from "./CustomerDialog.vue?vue&type=script&lang=js"
export * from "./CustomerDialog.vue?vue&type=script&lang=js"
import style0 from "./CustomerDialog.vue?vue&type=style&index=0&id=3ccc95ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports